import React, { useMemo } from "react";
import { Table } from "antd";

const CarePlanTable = ({ tableData, columns, tableLoading }) => {
  const dataSource = useMemo(
    () =>
      tableData?.map((item, index) => ({
        ...item,
        key: index,
      })) ?? [],
    [tableData],
  );

  return (
    <div className="tableContainerStyling care-plan-table">
      <div className="scroll-container" id="scrollableDiv">
        <Table
          className="tableStyling"
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          loading={tableLoading}
        />
      </div>
    </div>
  );
};

export default CarePlanTable;
